import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL || 'https://data.83868668.com/api';

export const ROLES = {
  ADMIN: 'admin',
  STAFF: 'staff',
};

export const ROLE_LABELS = {
  admin: 'Admin',
  staff: 'Nhân viên',
};

export function clearSession() {
  localStorage.removeItem('admin_token');
  localStorage.removeItem('admin_user');
}

const api = axios.create({ baseURL: API_URL, timeout: 60000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers['x-auth-token'] = token;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && localStorage.getItem('admin_token')) {
      clearSession();
      window.location.assign('/login');
    }
    return Promise.reject(error);
  }
);

export const errorMessage = (error, fallback = 'Lỗi kết nối server.') =>
  error?.response?.data?.message || fallback;

export default api;
